module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-copyright element-without-heading",
    attrs: {
      "id": "copyright-2"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "copyright-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width copyright-content"
  }, [_vm._v("Without limiting the rights under copyright(s) reserved below, no part of this publication may be reproduced, stored in, or introduced into a retrieval system or transmitted in any form or by any means (electronic, mechanical, photocopying, recording, or otherwise) without the prior permission of the publisher and the copyright owner.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("The content of this book is provided “AS IS.” The publisher and the author make no guarantees or warranties as to the accuracy, adequacy, or completeness of or results to be obtained from using the content of this book, including any information that can be accessed through hyperlinks or otherwise, and expressly disclaim any warranty expressed or implied, including but not limited to implied warranties of merchantability or fitness for a particular purpose. This limitation of liability shall apply to any claim or cause whatsoever, whether such claim or cause arises in contract, tort, or otherwise. In short, you, the reader, are responsible for your choices and the results they bring.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("The scanning, uploading, and distributing of this book via the internet or any other means without the permission of the publisher and copyright owner is illegal and punishable by law. Please purchase only authorized copies, and do not participate in or encourage piracy of copyrighted materials. Your support of the author’s rights is appreciated.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Unless otherwise noted, all scriptures are from the NEW KING JAMES VERSION®. Copyright© 1982 by Thomas Nelson, Inc. Used by permission. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Copyright © 2024 by Revival Today. All rights reserved.")]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_vm._v("Released: October 2024")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_vm._v("ISBN: 978-1-64457-766-0")])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_c('b', [_c('i', [_vm._v("Rise UP Publications")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_vm._v("United States of America")])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_vm._v("www.riseUPpublications.com")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left copyright-content"
  }, [_vm._v("Phone: 866-846-5123")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-faa2c7de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/print-copyright.vue
// module id = 63
// module chunks = 0